import { BlueLink } from "../buttons";
import Icon from "../socialControls/Icon";

const WIDTH_PX = "145px";

const EpisodeLocked = ({
  img,
  premiumContentTitle,
  episodeTitle,
  episodePrice,
  episodeCoins,
  by,
  storyTitle,
  backToStory,
  storySlug,
  children
}) => (
  <div className="px1 lg-px0 col-12 sm-col-10 md-col-9 mx-auto">
    <div className="a-page-spacer" />
    <div className="a-episode-page t-center t-pv0 t-pv3-ns bg-white">
      <div className="t-center w-100 w-80-ns t-pv3 shadow-3 gray-5">
        <h1 className="f3 lh-title t-mb3 t-ph3  t-center tc">
          {premiumContentTitle}
        </h1>
        <div className="flex flex-column flex-row-ns justify-center items-center items-start-ns t-mb3 t-pa3 bg-gray-0">
          <img
            className="db"
            style={{ flexBasis: `${WIDTH_PX}` }}
            src={img}
            width={WIDTH_PX}
            height={WIDTH_PX}
          />
          <div className="tc tl-ns t-pl3-ns lh-title t-mt2 t-mt0-ns">
            <p className="truncate-l t-mv1 t-ma0 f4">{episodeTitle}</p>
            <p className="truncate-l t-mt1">
              <span className="gray-6 fw3">{by} </span>
              {storyTitle}
            </p>
            <div className="flex justify-center justify-start-ns items-center">
              <p>
                {" "}
                {episodeCoins}: <strong>{episodePrice}</strong>{" "}
              </p>
              <img
                className="t-ml1 db grow"
                src="/images/ic-cre8.svg"
                width="24"
                height="24"
              />
            </div>
          </div>
        </div>
        <div className="t-pb3 t-ph1 t-ph3-m tc">{children}</div>
        <div className="tc">
          <BlueLink
            text={backToStory}
            path={storySlug}
            className="blue t-pl1"
            onClick={() => false}
          />
        </div>
      </div>
    </div>
  </div>
);

EpisodeLocked.defaultProps = {
  img: "/images/sample_images/sample_jpg.jpg",
  unlockPremiumContent: "EN episodeTitle",
  episodeTitle: "EN episodeTitle",
  episodePrice: "EN Episode price",
  episodeCoins: "122",
  backToStory: "Back to story",
  storyTitle: "EN story_title",
  storySlug: "#",
  by: "by"
};

export default EpisodeLocked;
